import { SystemStyleObject } from '@mui/system'
import { Theme } from '@mui/material/styles'

type SubmenuRowOptions = {
  active?: boolean
}

const transition =
  'background-color 160ms ease, background 160ms ease, border-color 160ms ease, box-shadow 160ms ease, color 160ms ease'

export const getLeftNavSubmenuItemSx = ({
  active = false,
}: SubmenuRowOptions = {}): SystemStyleObject<Theme> => ({
  minHeight: 30,
  px: 1.25,
  py: 0.5,
  my: 0.25,
  borderRadius: '8px',
  position: 'relative',
  overflow: 'hidden',
  transition,
  color: active
    ? 'var(--left-nav-subitem-active-color)'
    : 'var(--left-nav-subitem-color)',
  background: active ? 'var(--left-nav-subitem-active-bg)' : 'transparent',
  boxShadow: active ? 'var(--left-nav-subitem-active-shadow)' : 'none',

  '&:hover': {
    color: active
      ? 'var(--left-nav-subitem-active-color)'
      : 'var(--left-nav-subitem-hover-color)',
    background: active
      ? 'var(--left-nav-subitem-active-bg)'
      : 'var(--left-nav-subitem-hover-bg)',
    boxShadow: active
      ? 'var(--left-nav-subitem-active-shadow)'
      : 'var(--left-nav-subitem-hover-shadow)',
  },

  '&::after': active
    ? {
        content: '""',
        position: 'absolute',
        left: 4,
        top: 7,
        bottom: 7,
        width: 2,
        borderRadius: 4,
        backgroundColor: 'var(--left-nav-subitem-active-accent)',
      }
    : {},

  '& .MuiListItemIcon-root': {
    minWidth: 32,
    color: 'inherit !important',
  },

  '& .MuiListItemText-root': {
    minWidth: 0,
  },

  '& .MuiTypography-root, & svg': {
    color: 'inherit',
  },
})

export const leftNavSubmenuEmptySx: SystemStyleObject<Theme> = {
  minHeight: 30,
  px: 1.25,
  py: 0.5,
  color: 'var(--left-nav-subitem-muted-color)',

  '& .MuiTypography-root, & svg': {
    color: 'inherit',
  },
}

export const leftNavSubmenuSkeletonSx: SystemStyleObject<Theme> = {
  backgroundColor: 'var(--left-nav-subitem-skeleton-bg)',
}

export const leftNavSubmenuDividerSx: SystemStyleObject<Theme> = {
  borderColor: 'var(--left-nav-subitem-divider-color)',
}
